import Vue from 'vue/dist/vue.esm'

const [ w, d, content ] = [ window, document, 'news' ]

const apply = ( [items], [categories] ) => {

  items.map( item => {
    item.category = categories.filter( c => c.id == item.category )[0];
  });

  const el = d.querySelector('[data-plugin="block-news"]');

  const list = {
    el,
    data() {
      return {
        items,
        categories,
        amount: 0,
        cat: false,
        categoryFilter: []
      }
    },
    template: `
      <div class="block-news__app">
        <newsCat-tab @changeTab="changeTab" :categories="categories" :categoryFilter="categoryFilter" />
        <transition-group class="block-news__list" tag="ul" name="fade" mode="out-in">
          <li class="block-news__list-item" v-for="item in trimItems" :key="item.id">
            <a :href="item.href">
              <div class="head">
                <span class="date">{{ datetostr( item.date * 1000, "YYYY.MM.DD" ) }}</span>
                <span class="cat" :class="['is-cat-' + item.category.id ]">{{ item.category.name }}</span>
              </div>
              <div class="body"><p>{{ item.title }}</p></div>
            </a>
          </li>
          <!-- /.block-news__list-item -->
        </transition-group>
      </div>
    `,
    computed: {
      trimItems () {
        return this.filterItems().slice( 0, this.amount );
      }
    },
    methods: {
      filterItems () {
        if( this.cat == false ) return this.items;
        return this.items.filter( v => v.category.id == this.cat );
      },
      changeTab (cat) {
        if( cat == undefined ) this.cat = false;
        else this.cat = cat;
      },
      datetostr (unixtime,format) {
        return w.datetostr(unixtime,format);
      }
    },
    mounted () {
      this.categoryFilter = el.dataset.categoryFilter.split(',').map(v => parseInt(v)) || [];
      this.amount = parseInt(el.dataset.amount) || 8;
    }
  };

  const tab = {
    props: {
      categories: Array,
      categoryFilter: Array
    },
    template: `
      <nav class="block-news__tab">
        <ul>
          <li><a href="/news/" @click.stop.prevent="changeTab" class="current"><span>新着一覧</span></a></li>
          <li v-for="item in filteredCategories"><a :href="item.href" @click.prevent="changeTab( $event, item.id )"><span>{{ item.name }}</span></a></li>
        </ul>
      </nav>
    `,
    computed: {
      filteredCategories () {
        return this.categories.filter( cat => this.categoryFilter.includes( parseInt(cat.id) ));
      }
    },
    methods:{
      changeTab ( e, cat ) {
        Array.prototype.forEach.call( this.$el.querySelectorAll('li a.current'), el => el.classList.remove('current') );
        e.currentTarget.classList.add('current');
        this.$emit( 'changeTab', cat );
      }
    }
  };
  // タブコンポーネント追加
  Vue.component('newsCat-tab', tab );

  new Vue( list );
}

export default function BLOCK_NEWS () {
  $(() => $.when(
    $.getJSON('/asset/api/getArticles/', {content}),
    $.getJSON('/asset/api/getCategories/', {content}),
    w.load['block-news']
  ).then( apply ));
}